export const fontSizes = {
  // main text
  title: "clamp(1.75rem, calc(3vw * var(--container-scale, 1)), 3.25rem)",
  subtitle: "clamp(1.15rem, calc(1.75vw * var(--container-scale, 1)), 1.5rem)",
  bodyText: "clamp(1rem, calc(1.5vw * var(--container-scale, 1)), 1.25rem)",
  centeredBodyText:
    "clamp(1rem, calc(1.6vw * var(--container-scale, 1)), 1.375rem)",
  sectionHeader:
    "clamp(1.5rem, calc(2.25vw * var(--container-scale, 1)), 2.5rem)",
  sectionSubheader:
    "clamp(1.25rem, calc(1.85vw * var(--container-scale, 1)), 2rem)",

  // global viz styles
  vizTitle1: "clamp(0.9rem, calc(1.15vw * var(--container-scale, 1)), 1rem)",
  vizTitle2: "clamp(1.1rem, calc(1.35vw * var(--container-scale, 1)), 1.25rem)",

  // landing
  landingDescription:
    "clamp(0.95rem, calc(1.15vw * var(--container-scale, 1)), 1.15rem)",
  scrollIndicator:
    "clamp(0.85rem, calc(1.1vw * var(--container-scale, 1)), 1.1rem)",

  // intro section
  countryLabel:
    "clamp(0.875rem, calc(1.15vw * var(--container-scale, 1)), 1.375rem)",
  countryLabelNarrow:
    "clamp(0.75rem, calc(1vw * var(--container-scale, 1)), 1rem)",
  discrepancyLabel:
    "clamp(0.9rem, calc(1.15vw * var(--container-scale, 1)), 1rem)",
  arrow: "clamp(1.75rem, calc(4vw * var(--container-scale, 1)), 2.75rem)",
  reporterLabel: "clamp(0.7rem, calc(1vw * var(--container-scale, 1)), 0.9rem)",

  // mirroring viz
  mirroringLabels:
    "clamp(0.75rem, calc(1vw * var(--container-scale, 1)), 1.5rem)",
  mirroringNumbers:
    "clamp(1.15rem, calc(1.85vw * var(--container-scale, 1)), 1.75rem)",

  // reporting problem
  reportingProblemTitle:
    "clamp(1.125rem, calc(1vw * var(--container-scale, 1)), 1.35rem)",
  reportingProblemAxisLabels:
    "clamp(1.125rem, calc(0.8vw * var(--container-scale, 1)), 1.375rem)",
  reportingProblemAnnotations:
    "clamp(1rem, calc(0.8vw * var(--container-scale, 1)), 1.25rem)",
  reportingProblemCaption:
    "clamp(0.85rem, calc(0.8vw * var(--container-scale, 1)), 1rem)",

  // classification viz
  figure2CDLabels:
    "clamp(1.05rem, calc(1.15vw * var(--container-scale, 1)), 1.25rem)",
  figure2CDLabelsNarrow:
    "clamp(0.75rem, calc(0.95vw * var(--container-scale, 1)), 1.05rem)",
  figure2CDNodeLabels:
    "clamp(0.85rem, calc(1vw * var(--container-scale, 1)), 1rem)",
  figure2CDNodeLabelsNarrow:
    "clamp(0.65rem, calc(1.15vw * var(--container-scale, 1)), 0.85rem)",

  // animated sankey
  figure4LevelLabels: "clamp(1rem, 1vw, 1.25rem)",
  figure4NodeLabels:
    "clamp(0.75rem, calc(0.75vw * var(--container-scale, 1)), 1rem)",
  figure4NodeLabelsNarrow:
    "clamp(0.65rem, calc(1vw * var(--container-scale, 1)), 0.85rem)",
  figure4NodeLeftLabel:
    "clamp(0.85rem, calc(0.85vw * var(--container-scale, 1)), 1.15rem)",
  figure4NodeLeftLabelNarrow:
    "clamp(0.65rem, calc(1vw * var(--container-scale, 1)), 0.95rem)",

  // conclusion
  buttonLabels:
    "clamp(0.85rem, calc(1.25vw * var(--container-scale, 1)), 1.15rem)",
  citation: "clamp(0.75rem, calc(1vw * var(--container-scale, 1)), 1rem)",
  attribution: "clamp(0.75rem, calc(0.9vw * var(--container-scale, 1)), 1rem)",
};
